/**
 *  logManageMentModule
 *
 * Description  管理配置 日志管理 操作日志 
 * rebuild:SMG 2016-4-20
 */

'use strict';
angular.module("logManageMentOperationLogRouterModule", [])
    .config(['$stateProvider', function($stateProvider) {
        $stateProvider.
        state("manageconfig.logmanage.operationlog", {
                url: '/operationlog',
                views: {
                    'main@manageconfig.logmanage': {
                        templateUrl: './manageConfig/logManageMent/operationLog/operationLog_tpl.html',
                        controller: 'logManageMentOperationLogCtrl',
                    },
                    'footer@manageconfig.logmanage': {
                        templateUrl: './footer_tpl.html'
                    }
                }
            })
            .state("manageconfig.logmanage.distributeLog", {
                url: '/distributeLog',
                views: {
                    'main@manageconfig.logmanage': {
                        templateUrl: './manageConfig/logManageMent/distributeLog/distributeLog_tpl.html',
                        controller: 'logManageMentDistributeLogCtrl',
                    },
                    'footer@manageconfig.logmanage': {
                        templateUrl: './footer_tpl.html'
                    }
                }
            })
            .
        state("manageconfig.logmanage.myqueues", {
            url: '/myqueues',
            views: {
                'main@manageconfig.logmanage': {
                    templateUrl: './manageConfig/logManageMent/eventMonitoring/myQueues/myQueues_tpl.html',
                    controller: 'eventMonitoringMyQueuesCtrl',
                }
            }
        }).
        state("manageconfig.logmanage.allqueues", {
            url: '/allqueues',
            views: {
                'main@manageconfig.logmanage': {
                    templateUrl: './manageConfig/logManageMent/eventMonitoring/allQueues/allQueues_tpl.html',
                    controller: 'eventMonitoringAllQueuesCtrl',
                }
            }
        }).
        state("manageconfig.logmanage.securitylog", {
            url: '/securitylog',
            views: {
                'main@manageconfig.logmanage': {
                    templateUrl: './manageConfig/logManageMent/securityLog/securityLog_tpl.html',
                    controller: 'logManageMentSecurityLogCtrl',
                },
                'footer@manageconfig.logmanage': {
                    templateUrl: './footer_tpl.html'
                }
            }
        });
    }]);